export function fadeInStagger() {
  return {
    container: {
      hidden: { opacity: 1, x: 20, scale: 1 },
      visible: {
        opacity: 1,
        x: 0,
        scale: 1,
        transition: {
          delayChildren: 1.0,
          duration: 0.4,
          staggerChildren: 0.3,
        },
      },
    },
    item: {
      hidden: { y: -20, scale: 1 },
      visible: {
        y: 0,
        scale: 1,
        transition: {
          duration: 0.5,
        },
      },
    },
  };
}
